const comments = [
  {
    id: 1,
    name: '影迷小陈',
    text: '用了90影视快两年了，资源更新速度真的快，热门剧当天就能看。画质也一直很稳，手机端体验越来越好了！',
    meta: '活跃用户 · 2年',
  },
  {
    id: 2,
    name: '追剧达人Amy',
    text: 'APP端离线缓存功能太好用了，通勤路上也能追剧。片库也很全，一些冷门老片也能搜到，强烈推荐！',
    meta: 'APP用户 · 1年',
  },
  {
    id: 3,
    name: '电影爱好者老王',
    text: '作为一个电影迷，90影视的分类索引和专题片单做得真的很用心，帮我发现了好多之前没注意过的好片子。',
    meta: '资深用户 · 3年',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            用户评价
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            来自真实用户的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[960px] mx-auto">
          {comments.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 rounded-xl border border-background-200/60 p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm w-3 h-3 flex items-center justify-center"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{c.text}"
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/40">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.meta}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}